import { Head, usePage } from '@inertiajs/react'
import type { SharedProps } from '@/types'

type Props = {
  page: {
    title: string
    body: string
    slug: string
  }
}

export default function PageShow({ page }: Props) {
  const { app_url } = usePage<SharedProps>().props

  return (
    <>
      <Head title={page.title}>
        <meta head-key="description" name="description" content={`${page.title} - Gala Season`} />
        <meta head-key="og:title" property="og:title" content={`${page.title} - Gala Season`} />
        <meta head-key="og:type" property="og:type" content="website" />
        <meta head-key="og:url" property="og:url" content={`${app_url}/${page.slug}`} />
      </Head>

      <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8">
        <h1 className="text-3xl font-semibold tracking-tight font-serif">{page.title}</h1>
        <div
          className="prose prose-lg mt-8 max-w-none"
          dangerouslySetInnerHTML={{ __html: page.body }}
        />
      </div>
    </>
  )
}
